// Avatar portraits for each Gutachter persona (Exam-Modus)
export const PERSONA_AVATARS = {
  dr_mueller: {
    name: "Dr. Müller",
    role: "Sachlich & strukturiert",
    image: "https://static.prod-images.emergentagent.com/jobs/a8369d3b-c08b-46ea-8bde-9c80a64b83c0/images/90472415d8b6ad7b160413d6086dd40ccb1e8eabaf3a9772b39eb811b8cb6ca5.png",
  },
  dr_fischer: {
    name: "Dr. Fischer",
    role: "Kritisch & nachhakend",
    image: "https://static.prod-images.emergentagent.com/jobs/a8369d3b-c08b-46ea-8bde-9c80a64b83c0/images/75c920882daa0e2bf70cefb3cfe06e9935afd2e51e192ef6457f63a765f522b6.png",
  },
  dr_schmidt: {
    name: "Dr. Schmidt",
    role: "Empathisch & unterstützend",
    image: "https://static.prod-images.emergentagent.com/jobs/a8369d3b-c08b-46ea-8bde-9c80a64b83c0/images/57fe3c8113c5532aefd2f488b25b1fa363ce470704d0111d91b85c943bb21ae6.png",
  },
  dr_wagner: {
    name: "Dr. Wagner",
    role: "Skeptisch & direkt",
    image: "https://static.prod-images.emergentagent.com/jobs/a8369d3b-c08b-46ea-8bde-9c80a64b83c0/images/2a82714f011a0c903d2845cf12a2133c76f766531f0e0e9363f7257dbc95b27e.png",
  },
  default: {
    name: "Dr. Müller",
    role: "Ihr Gesprächspartner",
    image: "https://static.prod-images.emergentagent.com/jobs/a8369d3b-c08b-46ea-8bde-9c80a64b83c0/images/90472415d8b6ad7b160413d6086dd40ccb1e8eabaf3a9772b39eb811b8cb6ca5.png",
  }
};

// Stage-specific personas for the Learning Path (Lernpfad)
export const STAGE_PERSONAS = {
  ankommen: {
    id: "lea",
    name: "Lea",
    role: "Warm & einladend",
    character: "Lea empfängt Sie freundlich und ohne Druck. Sie hört zu und stellt einfache, offene Fragen.",
    image: "https://static.prod-images.emergentagent.com/jobs/64a086ae-b43a-4b88-8a45-2124427b60c4/images/d83e5d6cd0ca7369ef243889162f9a2e203d540140b2aee76ac537c877c9003f.png",
  },
  verstehen: {
    id: "dr_meyer",
    name: "Dr. Meyer",
    role: "Erklärend & geduldig",
    character: "Dr. Meyer erklärt ruhig und verständlich, worauf Gutachter achten und warum bestimmte Antwortmuster auffallen.",
    image: "https://static.prod-images.emergentagent.com/jobs/64a086ae-b43a-4b88-8a45-2124427b60c4/images/b44bfc1c512c1709161a922fb0f9ada6f45cc44eb4a6fdc930b110471ac2b78f.png",
  },
  aufarbeiten: {
    id: "anna",
    name: "Anna",
    role: "Empathisch & unterstützend",
    character: "Anna arbeitet einfühlsam mit Ihnen an konkreten Verbesserungen. Sie gibt Feedback und ermutigt Sie.",
    image: "https://static.prod-images.emergentagent.com/jobs/64a086ae-b43a-4b88-8a45-2124427b60c4/images/145ddec3813ffa629762960c997681de3d37181b7682b16cfc30b9dae8e0425c.png",
  },
  trainieren: {
    id: "coach_stefan",
    name: "Coach Stefan",
    role: "Motivierend & direkt",
    character: "Coach Stefan trainiert mit Ihnen wie ein sportlicher Trainer — direkt, motivierend und mit klarem Feedback.",
    image: "https://static.prod-images.emergentagent.com/jobs/64a086ae-b43a-4b88-8a45-2124427b60c4/images/9cf45e3679af73913a4665da28188f1263d2edd9efad5e9c6673ea1ddf0bc855.png",
  },
  vertiefen: {
    id: "dr_kohl",
    name: "Dr. Kohl",
    role: "Analytisch & präzise",
    character: "Dr. Kohl stellt gezielte, kritische Nachfragen um Ihre Belastbarkeit zu testen. Sachlich aber fair.",
    image: "https://static.prod-images.emergentagent.com/jobs/64a086ae-b43a-4b88-8a45-2124427b60c4/images/d836e3b7114251ee88b3c334ce8a281b4e68488c113653d77f14be83800d8170.png",
  },
  simulation: {
    id: "dr_mueller",
    name: "Dr. Müller",
    role: "Sachlich & neutral",
    character: "Dr. Müller führt eine realistische MPU-Simulation durch — neutral, formal und professionell wie ein echter Gutachter.",
    image: "https://static.prod-images.emergentagent.com/jobs/a8369d3b-c08b-46ea-8bde-9c80a64b83c0/images/90472415d8b6ad7b160413d6086dd40ccb1e8eabaf3a9772b39eb811b8cb6ca5.png",
  },
};
